module.exports = __webpack_public_path__ + "img/P150T_weapon_145.0a10b35b.png";